import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=410fbe0c&"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts&"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports